import Axios from 'axios';
import { URL_API } from '../../constants';
import { getLocalStorage, getUrlParam, isTokenAboutExpire, setLocalStorage } from '../../utils';

export const getAutotaskAuthToken = data =>
  Axios({
    method: 'POST',
    url: `${URL_API}/api/autotask/auth`,
    data
  }).then(res => res.data.message);

const savedTokenKey = 'autotaskToken';

const getNormalizedQueryParams = () => {
  const queryString = window.location.search;
  const paramsArray = queryString.replace('?', '').split('&');
  const signatureValue = paramsArray
    .find(param => param.startsWith('signature='))
    .split('signature=')[1];
  const filteredParamsArray = paramsArray.filter(param => !param.startsWith('signature='));
  const filteredQueryString = filteredParamsArray.join('&');

  return {
    signature: signatureValue,
    url_params: filteredQueryString,
    app_id: getUrlParam('vendorsuppliedid'),
    resource_id: getUrlParam('resourceid')
  };
};

export const requestToAccessToken = async ({ maxRetryCount = 3 } = {}) => {
  const data = getNormalizedQueryParams();
  const locallyStoredToken = getLocalStorage(savedTokenKey);
  if (locallyStoredToken && !isTokenAboutExpire(locallyStoredToken)) {
    return locallyStoredToken;
  }

  const getTokenWithRetry = async (requestPayload, retryCount = 1) => {
    try {
      const res = await getAutotaskAuthToken(requestPayload);
      return res;
    } catch (err) {
      if (retryCount < maxRetryCount) {
        const res = await getTokenWithRetry(data, retryCount + 1);
        return res;
      }
      throw err;
    }
  };

  const { access_token: token } = await getTokenWithRetry(data);
  setLocalStorage({ [savedTokenKey]: token });
  return token;
};
